import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { useProfileStore } from "../../../store/useUserStore";
import { useEffect, useState } from "react";
import api from "../../../api/api";
import { t } from "i18next";
import { toast } from "react-toastify";
import CourseCard from "../../../components/Course/CourseCard";

const CourseType = () => {
    const navigate = useNavigate();
    const { courseTypeId } = useParams();
    const {
        mealId,
        transportId,
    } = useProfileStore((state: any) => state);
    const [courses, setCourses] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };
    const { setHomePageShow, students, selectedStudent, setSelectedStudent, setLoading, } = useProfileStore();

    useEffect(() => {
        if (selectedStudent) {
            getCourseTypeCourses(selectedStudent.id.toString());
        }
    }, []);

    function getCourseTypeCourses(studentId: string) {
        setLoading(true);
        api
            .get(
                `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=school&student_id=${studentId}&course_type_id=${courseTypeId}&action_type=course_type_search`,
            )
            .then((res) => {
                console.log("res", res.data.data);



                // proceessed course to get day and time
                const processedCourses = res.data.data.courses.map((course: any) => {
                    const allDaysSet = new Set<string>();

                    course.time_slots?.forEach((timeslot: any) => {
                        allDaysSet.add(timeslot.day); // e.g., "Monday"
                    });

                    const dayOrder = [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                        "Sunday",
                    ];

                    const dayShortMap: { [key: string]: string } = {
                        Monday: "Mon",
                        Tuesday: "Tues",
                        Wednesday: "Wed",
                        Thursday: "Thur",
                        Friday: "Fri",
                        Saturday: "Sat",
                        Sunday: "Sun",
                    };

                    const sortedDays = dayOrder
                        .filter((day) => allDaysSet.has(day))
                        .map((day) => dayShortMap[day]);

                    return {
                        ...course,
                        concatDayArray: sortedDays,
                    };
                });

                setCourses(processedCourses);
            })
            .catch((err) => {
                console.log("err", err);
                toast.error(t("server_error"));
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function handleSelectStudent(studentObj: any) {
        // console.log("handleSelectStudnet", studentObj.id, JSON.stringify(studentObj))
        localStorage.setItem("selectedStudent", JSON.stringify(studentObj));
        setSelectedStudent(studentObj);
        getCourseTypeCourses(studentObj.id);
        setIsOpen(false);
    }
    
    return (
        <div className="pb-28 container">
            <div className="mb-2 grid grid-cols-4 px-2">
                <div>
                    <IoIosArrowBack
                        size={28}
                        color="#000"
                        onClick={() => {
                            setHomePageShow("school");
                            setSelectedStudent(selectedStudent);
                            return navigate(
                                `/school`,
                            );
                        }}
                    />
                </div>
                <div className="text-center col-span-2 text-lg font-medium truncate">
                    {courseTypeId === mealId ? t("home.school_meal") : t("home.transport")}
                </div>
                <div></div>
            </div>

            {/* Student Dropdown */}
            <div className="py-4 relative dropdown-container">
                <button
                    className="text-lg font-light rounded-3xl px-2 py-1 bg-white shadow-course-card flex items-center w-full gap-2"
                    onClick={toggleDropdown}
                >
                    <img
                        className="h-6 w-6 rounded-3xl mr-2"
                        alt=""
                        src={
                            selectedStudent?.profile_pic ||
                            "/assets/img/default-profile.jpg"
                        }
                    />
                    <span className="truncate w-40 overflow-hidden text-ellipsis text-start whitespace-nowrap">
                        {selectedStudent?.name || t("home.no_student_selected")}
                    </span>
                </button>

                {isOpen && (
                    <div
                        className="absolute mt-2 bg-white shadow-course-card rounded-lg w-full z-20"
                        style={{ maxHeight: "20rem", overflowY: "auto" }}
                    >
                        {students.map((student: any) => (
                            <div
                                key={student.id}
                                className="flex items-center px-2 md:px-4 py-2 hover:bg-gray-100 cursor-pointer "
                                onClick={() => handleSelectStudent(student)}
                            >
                                <img
                                    className="h-10 w-10 rounded-lg mr-2"
                                    alt=""
                                    src={
                                        student?.profile_pic ||
                                        "/assets/img/default-profile.jpg"
                                    }
                                />
                                <span className="truncate">{student.name}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="pt-2 col-12">
                <div>
                    {courses.length > 0 ? (
                        <div className="grid grid-cols-2 gap-2 item-start">
                            {courses.map((branch: any, index: number) => (
                                <CourseCard
                                    explore={false}
                                    course_id={branch.course_branch_id}
                                    name={branch.course_name}
                                    concatDayArray={branch.concatDayArray}
                                    images={branch.images}
                                    pricing_packages={branch.pricing_packages}
                                    promotions_tag={branch.promotions_tag}
                                    schedule={branch.time_slots}
                                    isFull={branch.is_full}
                                />
                            ))}
                        </div>
                    ) : (
                        <div
                            className="col-12 text-center content-center"
                            style={{ height: "60vh" }}
                        >
                            <div className="text-lg font-semibold">
                                {courseTypeId === mealId ? t("home.noSchoolMeal") : courseTypeId === transportId ? t("home.noTransport") : t("home.no_results_found")}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CourseType;